import { memo } from 'react';
import { FieldTextCompact } from '@stratumn/atomic';
import type {
  TextareaSchemaField,
  BaseTypeBodyProps
} from 'schemaBuilder/types';
import { useSetCallback } from 'schemaBuilder/modules/action/hooks/fields';

import useStyles from './textarea.style';

interface Props extends BaseTypeBodyProps {
  schemaField: TextareaSchemaField;
}

const TextareaBody = ({ schemaField, readonly = false, path }: Props) => {
  const classes = useStyles();
  const handlePlaceholderUpdate = useSetCallback(`${path}.placeholder`);
  return (
    <div className={classes.body}>
      <FieldTextCompact
        data-cy="placeholder"
        disabled={readonly}
        value={schemaField.placeholder}
        label="Placeholder"
        onValueChange={handlePlaceholderUpdate}
      />
    </div>
  );
};

export default memo(TextareaBody);
